import { IControllerConstructor } from 'angular';
import { TransportZonesController } from './transport-zones.controller';
import * as transportZonesRoutesModule from './transport-zones.routes';
import { TransportZoneEditController } from './edit/transport-zone-edit.controller';

export const initialise = () => {
  angular.module('app.transport-zones', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ])
  .controller('transportZonesController', <IControllerConstructor>TransportZonesController)
  .controller('transportZoneEditController', <IControllerConstructor>TransportZoneEditController);

  transportZonesRoutesModule.initialise();
};